import React from 'react';
import { UPLOAD_FILE_CONSTRAINTS, UPLOAD_MEDIA_FILE_ERROR_TYPE } from '../../utils/constants';
import { ButtonContainer, UploadFileInput, UploadText } from './UploadMediaButtonAlt.styles';
import { ReactComponent as ImagePlusIcon } from '../../assets/icons/image-plus.svg';
import heic2any from 'heic2any';
import { getAudioDuration } from '../../utils/audio';

const UploadMediaButtonAlt = ({ type, onChange, disabled, setError, multiple = false, title }) => {
  const acceptedExtensionsText = UPLOAD_FILE_CONSTRAINTS[type].ALLOWED_EXTENSIONS_TEXT;

  const validateFile = async file => {
    const allowedExtensions = UPLOAD_FILE_CONSTRAINTS[type].ALLOWED_EXTENSIONS;
    const maxFileSizeInBytes = UPLOAD_FILE_CONSTRAINTS[type].MAX_SIZE_IN_BYTES;

    if (file.size < maxFileSizeInBytes) {
      const fileType = file.type.split('/')[1];
      if (allowedExtensions.includes(fileType)) {
        if (type === UPLOAD_FILE_CONSTRAINTS.TYPE.AUDIO) {
          try {
            const audioDuration = await getAudioDuration(file);
            if (audioDuration < UPLOAD_FILE_CONSTRAINTS.AUDIO.MIN_DURATION_IN_SECONDS) {
              setError(prev => [...prev, { type: UPLOAD_MEDIA_FILE_ERROR_TYPE.AUDIO_DURATION, fileName: file.name }]);
            }
          } catch (error) {
            setError(prev => [...prev, { type: UPLOAD_MEDIA_FILE_ERROR_TYPE.FILE_TYPE, fileName: file.name }]);
          }
        }
        if (fileType === 'heic') {
          const fileName = file.name.split('.')[0];
          const jpeg = await heic2any({ blob: file });
          const newFile = new File([jpeg], `${fileName}.png`, { type: jpeg.type });
          return newFile;
        }
      } else {
        setError(prev => [...prev, { type: UPLOAD_MEDIA_FILE_ERROR_TYPE.FILE_TYPE, fileName: file.name }]);
      }
    } else {
      setError(prev => [...prev, { type: UPLOAD_MEDIA_FILE_ERROR_TYPE.FILE_SIZE, fileName: file.name }]);
    }
    return file;
  };

  return (
    <ButtonContainer>
      <UploadFileInput
        type="file"
        title=""
        value=""
        disabled={disabled}
        multiple={multiple}
        onChange={async e => {
          const { files: newFiles } = e.target;
          if (newFiles.length) {
            const media = [];
            for (const newFile of [...newFiles]) {
              const file = await validateFile(newFile);

              if (file) {
                media.push({ file, url: URL.createObjectURL(file) });
              }
            }
            if (media.length) {
              onChange(media);
            }
          }
        }}
        accept={acceptedExtensionsText}
      />
      <ImagePlusIcon color="#1672ba" />
      <UploadText>{title ? title : 'Click to upload'}</UploadText>
    </ButtonContainer>
  );
};

export default UploadMediaButtonAlt;
